const device = (function () {
    const ua = window.navigator.userAgent;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    const ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    return {
        ios: ipad || iphone || ipod,
        android: android
    };
})();

export default device;